<template>
  <el-container style="display: block;">
    <!-- <div >
      <img @click="goHome()"  :src="require('@/assets/image/goback.png')" style="position: absolute;left: 0;top: 0;z-index: 1008;opacity: 0.8;" :style="{'height':screenHeight*0.03+'px'}" >
    </div> -->
    <div style="position: fixed;z-index: 1005;background-color: #000;z-index: 1005;right: 0;top: 0;"
         :style="{'width':screenHeight*0.42+'px','height':screenHeight*0.24+'px'}">
      <video width="100%" height="100%" ref="videoPlayer" @ended="restartVideo" controls
             controlslist="nodownload noplaybackrate" disablePictureInPicture="true" id="myVideo1" v-if="ishows">
        <source :src="index_url" type="video/mp4">

      </video>
    </div>
    <div :style="{'width':screenWidth+'px','height':screenHeight+'px'}" @click="toPage()"
         style="z-index: 0;position: absolute;top: 0;">

      <img id='imageg' :src="back" style="width: 100%;height: 100%;">


    </div>

    <div style="display: flex;flex-wrap: wrap;position: absolute;" @click="toPage()"
         :style="{'width':screenWidth+'px','height':screenHeight+'px'}">
      <!--      <div>-->
      <!--        <img :src="require('@/assets/image/shop.png')"   :height="screenHeight*0.42+'px'" @click="toPage()" style="position: absolute;top:5%;z-index: 5;width: 240px;height: 48px;left: 28%;">-->
      <!--      </div>-->

      <div>
        <img :src="list[15]['url']" :height="screenHeight*0.26+'px'" @click="open()"
             style="position: absolute;top: 5%;z-index: 1;left: 45%;">
      </div>
      <div>
        <img :src="list[24]['url']" :height="screenHeight*0.26+'px'" @click="open()"
             style="position: absolute;top: 5%;z-index: 1;left: 59%;">
      </div>


      <div>
        <img :src="list[0]['url']" :height="screenHeight+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 1;left: -8%;">
      </div>
      <div>
        <img :src="list[23]['url']" :height="screenHeight*0.8+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 0;left: 39%;">
      </div>
      <div>
        <img :src="list[13]['url']" :height="screenHeight*0.8+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 0;left: 69%;">
      </div>


      <div>
        <img :src="list[1]['url']" :height="screenHeight*0.4+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 5;left: -1%;">
      </div>
      <div>
        <img :src="list[2]['url']" :height="screenHeight*0.27+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 5;left: 9%;">
      </div>
      <div>
        <img :src="list[3]['url']" :height="screenHeight*0.40+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 5;left: 17%;">
      </div>
      <div>
        <img :src="list[5]['url']" :height="screenHeight*0.31+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 5;left: 27%;">
      </div>
      <div>
        <img :src="list[9]['url']" :height="screenHeight*0.28+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 5;left: 46%;">
      </div>

      <div>
        <img :src="list[17]['url']" :height="screenHeight*0.20+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 5;left: 60%;">
      </div>
      <div>
        <img :src="list[25]['url']" :height="screenHeight*0.24+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 5;left: 72%;">
      </div>
      <div>
        <img :src="list[20]['url']" :height="screenHeight*0.24+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 5;left: 79%;">
      </div>


      <div>
        <img :src="list[21]['url']" :height="screenHeight*0.6+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 1;left: 2%;">
      </div>
      <div>
        <img :src="list[16]['url']" :height="screenHeight*0.6+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 1;left: 10%;">
      </div>
      <div>
        <img :src="list[22]['url']" :height="screenHeight*0.6+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 1;left: 15%;">
      </div>
      <div>
        <img :src="list[4]['url']" :height="screenHeight*0.6+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 1;left: 23%;">
      </div>
      <div>
        <img :src="list[6]['url']" :height="screenHeight*0.6+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 1;left: 32%;">
      </div>
      <div>
        <img :src="list[7]['url']" :height="screenHeight*0.6+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 1;left: 38%;">
      </div>
      <div>
        <img :src="list[8]['url']" :height="screenHeight*0.6+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 1;left: 46%;">
      </div>
      <div>
        <img :src="list[10]['url']" :height="screenHeight*0.6+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 1;left: 54%;">
      </div>
      <div>
        <img :src="list[18]['url']" :height="screenHeight*0.6+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 1;left: 60%;">
      </div>
      <div>
        <img :src="list[11]['url']" :height="screenHeight*0.6+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 1;left: 69%;">
      </div>
      <div>
        <img :src="list[12]['url']" :height="screenHeight*0.6+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 1;left: 76%;">
      </div>
      <div>
        <img :src="list[14]['url']" :height="screenHeight*0.6+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 1;left: 83%;">
      </div>

      <div>
        <img :src="list[19]['url']" :height="screenHeight*0.6+'px'" @click="open()"
             style="position: absolute;bottom: 0;z-index: 5;left: 92%;">
      </div>

    </div>


    <div class="beian1">
      <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank"
         style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>
    </div>

<!--名称图标-->
    <div class="logo">
      <div class="logo-text" :style="{ fontSize: dynamicFontSize22 + 'px' }">{{company}}</div>
      <img :src=src class="logo-img"></img>
    </div>

    <!--手机验证码登录-->
    <div class="telCode" v-if="isshow == 1">
      <div class="telCode-title" :style="{ fontSize: dynamicFontSize22 + 'px' }"><span class="telCode-title-span" >手机验证码</span>登录</div>
      <div class="telCode-input" style="z-index: 0;">
        <el-input placeholder="请输入手机号码" v-model="phone" class="telCode-input-tel"></el-input>
        <!-- <el-autocomplete
          class="inline-input telCode-input-tel"
          v-model="phone"
          :fetch-suggestions="querySearch"
          placeholder="请输入手机号码"
          style="z-index: 9999;"
        ></el-autocomplete> -->
        <div class="telCode-input-row">
          <el-input placeholder="请输入验证码" v-model="VerificationCode" class="telCode-input-row-code"></el-input>
          <button class="telCode-input-row-btn" @click="sendCaptcha" :disabled="isCounting" :style="{ fontSize: dynamicFontSize16 + 'px' }">{{ countdownText }}</button>
        </div>
        <button class="telCode-input-login" @click="loginCode()" :style="{ fontSize: dynamicFontSize18 + 'px' }">登录/注册</button>
        <div class="font-color" @click="loginChange(2)" :style="{ fontSize: dynamicFontSize16 + 'px' }">手机密码登录</div>
      </div>
      <div class="telCode-bottom" :style="{ fontSize: dynamicFontSize14 + 'px' }">
        您登录既同意<span class="font-color2">用户服务协议、隐私政策</span> 和 <span class="font-color2">授权许可协议</span>，如您成为会员，即视为同意<span class="font-color2">会员服务协议</span>
      </div>
    </div>

    <!--手机密码登录-->
    <div class="telCode" v-if="isshow == 2">
      <div class="telCode-title" :style="{ fontSize: dynamicFontSize22 + 'px' }"><span class="telCode-title-span" >手机密码</span>登录</div>
      <div class="telCode-input">
        <el-input placeholder="请输入手机号码" v-model="phone" class="telCode-input-tel"></el-input>
        <el-input placeholder="请输6-12位密码" v-model="password" show-password class="pw"></el-input>
        <button class="telCode-input-login" @click="login()" :style="{ fontSize: dynamicFontSize18 + 'px' }">登录</button>
        <div class="flex-row" :style="{ fontSize: dynamicFontSize14 + 'px' }">
          <div class="font-color" @click="loginChange(1)" >手机验证码登录</div>
          <div class="font-color" @click="loginChange(3)" >更改密码</div>
        </div>

      </div>
      <div class="telCode-bottom" :style="{ fontSize: dynamicFontSize14 + 'px' }">
        您登录即同意<span class="font-color2">用户服务协议、隐私政策</span> 和 <span class="font-color2">授权许可协议</span>，如您成为会员，即视为同意<span class="font-color2">会员服务协议</span>
      </div>
    </div>
<!--    更改密码-->
    <div class="telCode" v-if="isshow == 3">
      <div class="telCode-title" :style="{ fontSize: dynamicFontSize22 + 'px' }"><span class="telCode-title-span" >更改密码</span></div>
      <div class="telCode-input">
        <el-input placeholder="请输入手机号码" v-model="phone"></el-input>
        <div class="telCode-input-row">
          <el-input placeholder="请输入验证码" v-model="VerificationCode" class="telCode-input-row-code"></el-input>
          <button class="telCode-input-row-btn" @click="sendCaptcha" :disabled="isCounting" :style="{ fontSize: dynamicFontSize16 + 'px' }">{{ countdownText }}</button>
        </div>
          <el-input placeholder="请输6-12位密码"   v-model="password" show-password ></el-input>
        <button class="telCode-input-changepw" @click="changePass()" :style="{ fontSize: dynamicFontSize18 + 'px' }">更改密码</button>
        <div class="font-color3" @click="loginChange(2)" :style="{ fontSize: dynamicFontSize14 + 'px' }"><span class="font-color3-color" >想起密码?</span>去登录</div>
      </div>
    </div>

    <!--    注册-->
    <div class="telCode login" v-if="isshow == 4">
      <div class="telCode-title" :style="{ fontSize: dynamicFontSize22 + 'px' }">注册登录</div>
      <div class="telCode-input">
        <el-input placeholder="请输入手机号码" v-model="phone"></el-input>
        <div class="telCode-input-row1">
          <el-input placeholder="请输入验证码" v-model="VerificationCode" class="telCode-input-row-code"></el-input>
          <button class="telCode-input-row-btn" @click="sendCaptcha" :disabled="isCounting" :style="{ fontSize: dynamicFontSize16 + 'px' }">{{ countdownText }}</button>
        </div>
        <el-input placeholder="请输6-12位密码"  v-model="password" show-password ></el-input>
        <el-input placeholder="请确认密码" v-model="password" show-password class="pw1"></el-input>
        <button class="telCode-input-changepw">注册</button>
        <el-checkbox v-model="checked" class="is-checked">我已经阅读并同意<span class="font-color">用户服务协议、隐私政策</span>和<span class="font-color">授权许可协议</span></el-checkbox>
        <div class="font-color4" @click="loginChange(2)"><span class="font-color3-color" >已有账号?</span>立即登录</div>
      </div>
    </div>

  </el-container>

  <!--  @click="login()"-->
  <!--  @click="register()"-->


  <!--  <el-input placeholder="密码"  prefix-icon="el-icon-key" v-model="password" show-password></el-input>-->
  <!--  <el-input-->
  <!--    placeholder="用户名"-->
  <!--    prefix-icon="el-icon-user"-->
  <!--    v-model="name">-->
  <!--  </el-input>-->


</template>


<script>

export default {
  data() {
    return {
      list: [],
      src:'https://images.yoooooo.com/crm/reseller/logo.png',
      back: 'https://images.yoooooo.com/image/others/changjing/img/changjing/2/1.gif',
      backs: ['https://images.yoooooo.com/image/others/changjing/img/changjing/4/1.gif', 'https://images.yoooooo.com/image/others/changjing/img/changjing/2/1.gif', 'https://images.yoooooo.com/image/others/changjing/img/changjing/3/1.gif'],
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      vwidth: (window.innerWidth - 20) / 20,
      vheight: window.innerHeight / 200,
      index_url: 'https://video.universepower.cn/yuzhouzhimi/universepower_hunshayuzhou_zhiyeren_jinshasha_video3.mp4',
      ishows: false,
      phone: '',
      password: '',
      uIp: '',
      info: this.$route.query.info.replace(/ /g, "+"),
      // 手机验证码登
      telCode: '', // 手机号
      VerificationCode: '', //录 验证码
      isshow:1,
      countdown: 60,
      isCounting: false,
      interval:null,
      baseFontSize12:12,
      baseFontSize14:14,
      baseFontSize16:16,
      baseFontSize18:18,
      baseFontSize22:22,
      dynamicFontSize12:12,
      dynamicFontSize14:14,
      dynamicFontSize16:16,
      dynamicFontSize18:18,
      dynamicFontSize22:22,
      company:'宇宙之幂(深圳)科技集团有限公司',
      restaurants:[]

    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize); //font

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize); //font
  },
  created() {
    
    this.loadList()
    this.getScreen()
    if(localStorage.getItem('phone')){
      this.phone = localStorage.getItem('phone')
    }

  },
  computed: {
    countdownText() {
      return this.isCounting ? `${this.countdown}s` : '获取验证码';
    },
    dynamicFontSize() { //font
      const screenWidth = window.innerWidth;
      return this.baseFontSize12 * (screenWidth / 1920);
      return this.baseFontSize14 * (screenWidth / 1920);
      return this.baseFontSize16 * (screenWidth / 1920);
      return this.baseFontSize18 * (screenWidth / 1920);
      return this.baseFontSize22 * (screenWidth / 1920);

    }
  },
  methods: {
    // querySearch(queryString, cb) {
    //   var restaurants = this.restaurants;
    //   var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
    //   // 调用 callback 返回建议列表的数据
    //   cb(results);
    // },
    handleResize() {
      this.dynamicFontSize12 = this.baseFontSize12 * (window.innerWidth / 1920);
      this.dynamicFontSize14 = this.baseFontSize14 * (window.innerWidth / 1920);
      this.dynamicFontSize16 = this.baseFontSize16 * (window.innerWidth / 1920);
      this.dynamicFontSize18 = this.baseFontSize18 * (window.innerWidth / 1920);
      this.dynamicFontSize22 = this.baseFontSize22 * (window.innerWidth / 1920);
    },
    register() {
      this.$router.push({path: '/Register?info=' + this.info})
    },
    // countdownText() {
    //   return this.isCounting ? `${this.countdown}s` : '获取验证码';
    // },
    loginChange(id){
      this.isshow = id
      this.VerificationCode = ''
      // this.phone = ''
      this.password = ''
      this.countdown = 60
      this.isCounting = false
      if(this.interval){
        clearInterval(this.interval); // 清除定时器
        this.interval = null;
      }
    },
    sendCaptcha() {
      if (this.isCounting) return;
      // 这里可以添加发送验证码的逻辑，例如调用 API
      this.sendMsg();

    },
    startCountdown() {
      this.isCounting = true;
      this.countdown = 60;

      this.interval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.interval);
          this.isCounting = false;
        }
      }, 1000);
    },
    validatePassword(rule, value, callback) {
      if (value !== this.password) {
        callback(new Error('密码不匹配'));
      } else {
        callback();
      }
    },
    isValidPhone() {
      // 手机号正则表达式（中国大陆手机号）
      const phoneRegex = /^1[3-9]\d{9}$/;

      return phoneRegex.test(this.phone);
    },
    sendMsg(){
      // this.startCountdown();
      if(!this.isValidPhone()){
        this.msg('请输入正确的手机号码','error');
        return false
      }
      const form = {'phone':this.phone, 'info': this.info}
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	data:form,
      	url:'https://tossp.yoooooo.com/index.php/index/data/sendMsgs'
      })
      .then(res=>{
        if(res.data.code == 200){
          this.startCountdown();
        }
        if(res.data.code == 202){
          this.msg(res.data.data,'error');
        }

      })
      .catch(err=>{

      });
    },
    login() {

      const form = {'phone': this.phone, 'password': this.password, 'info': this.info}
      const axiosInstance = this.$axios.create({
        headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
        method: 'post',
        data: form,
        url: 'https://tossp.yoooooo.com/index.php/index/data/loginReseller'
      })
        .then(res => {
          if (res.data.code == 200) {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('phone', this.phone);
            
            this.$router.push({path: '/Reseller?id=' + this.info})
          } else {
            this.msg('用户名密码错误', 'error');
          }

        })
        .catch(err => {

        });
    },
    loginCode() {
      const form = {'phone': this.phone, 'captcha': this.VerificationCode, 'info': this.info}
      const axiosInstance = this.$axios.create({
        headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
        method: 'post',
        data: form,
        url: 'https://tossp.yoooooo.com/index.php/index/data/loginCodeReseller'
      })
        .then(res => {
          if (res.data.code == 200) {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('phone', this.phone);
            this.$router.push({path: '/Reseller?id=' + this.info})
          } else {
            this.msg(res.data.msg, 'error');
          }

        })
        .catch(err => {

        });
    },
    changePass() {
      const form = {'phone': this.phone, 'captcha': this.VerificationCode, 'password':this.password,'info': this.info}
      const axiosInstance = this.$axios.create({
        headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
        method: 'post',
        data: form,
        url: 'https://tossp.yoooooo.com/index.php/index/data/changePassReseller'
      })
        .then(res => {
          if (res.data.code == 200) {
            this.isshow = 2
          } else {
            this.msg(res.data.msg, 'error');
          }

        })
        .catch(err => {

        });
    },
    goHome() {

      // this.$router.push('/');
    },
    restartVideo() {
      this.$refs.videoPlayer.currentTime = 0;
      this.$refs.videoPlayer.play();
    },
    opens(url) {


      this.ishows = false
      this.index_url = ""
      setTimeout(() => {
        this.ishows = true
        this.index_url = url

        this.$nextTick(() => {
          if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.play();
          }
        });
      }, 200);

    },
    getScreen() {
      if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        window.location.href = 'http://m.universe.top/Login?info='+this.info

      }

    },
    startVideo() {
      var that = this
      var bac = 0
      var bkey = 0
      this.interval2 = setInterval(() => {
        if (bac > 7) {
          if (bkey == 2) {
            bkey = 0
          } else {
            bkey = bkey + 1
          }
          that.back = that.backs[bkey]
          bac = 0
        } else {

          bac = bac + 1
        }
        that.list.forEach(function (item, index) {

          if (item['num'] < item['nums']) {
            item['num'] = item['num'] + 1;
            that.$set(that.list, index, item);
            // that.$set(that.list, index, {'id':item['id'],'img':item['img'],'name':item['name'],'url':item['url'],'num':item['num']+1,'nums':item['nums'],'typea':item['typea'],'typeb':item['typeb'],'typec':item['typec'],'typed':item['typed']});
          } else {
            var tt = Math.floor(Math.random() * item['imgs'].length)
            item['url'] = item['imgs'][tt]
            item['num'] = 0;

            that.$set(that.list, index, item);
          }

        })

      }, 1000);

    },

    toPage(name) {
      // this.$router.push('/shop1');
    },
    loadList() {
      const axiosInstance = this.$axios.create({
        headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
        method: 'get',
        params: {
          name: '宇宙一次幂(深圳)机器人有限公司',
          info:this.info

        },
        url: 'https://tossp.yoooooo.com/index.php/index/data/shopListRese'
      })
        .then(res => {
          this.list = res.data.list;
          this.index_url = res.data.index_url;
          this.src = res.data.logo
          this.company = res.data.company
          this.opens(this.index_url)

          // this.list.forEach(function(item, index) {
          //    item['typed'] = 0;
          //    item['typec'] = 2;
          //    item['typeb'] = 2;
          //    item['typea'] = 0;

          // })
          this.startVideo()

        })
        .catch(err => {

        });
    },
    msg(msg, type) {
      this.$message({
        message: msg,
        type: type
      });
    },


  }


}
</script>

<style scoped lang="scss">
/deep/.el-input .el-input__inner{
  border:1px solid #262626;
  background: rgb(16,16,16);
  height: 4vh;
  line-height: 4vh;
  font-size: 16px;
  // color:#6d6b6b;
  color:#fff;
}
/deep/.el-input .el-input__inner::placeholder {
  color: #6d6b6b; /* 将颜色改为您想要的颜色 */
}
.logo{
  position: relative;
  z-index: 999;
  text-align: center;
  margin:10px auto;
  &-text{
    font-size: 30px;
    color: rgb(233,233,11);
  }
  &-img{
    width: 90px;
    height: 89px;
    margin-top:20px;
  }
}
.box {
  margin: calc(28vh - 148px) auto;
  background: rgb(13,13,13);
  box-shadow: 0px 2px 6px 2px rgba(73, 73, 73, 0.23);
  border: 1px solid #6d53f4;
  position: relative;
  z-index: 999;
  border-radius: 20px;
  padding: 1vh 0px 0px;
}

.btn {
  width: 100%;
  border-radius: 4px;
  text-align: center;
  height: 4vh;
  line-height: 4vh;
  color: #fff;
  background: #6000ff;
  box-shadow: none;
  border: 0px;
  font-size: 24px;
}

.yzbtn {
  background: #6000ff;
  font-size: 16px;
  color: #fff;
  border: 1px solid #6000ff;
  border-radius: 5px;
}
.flex-row{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.font-color {
  color: #fae83e;
  font-size: 14px;
  margin-top: 5px;

}
.font-color2{
  color: #b6cff8;
}
.font-color3{
  font-size: 14px;
  color: #fae83e;
  text-align: center;
  margin-bottom: 20px;
  letter-spacing: 1px;
  &-color{
    color:#fff;
    margin-right:5px
  }
}
.font-color4{
  @extend .font-color3;
  margin-top: 3vh;
  font-size: 18px;
}
.pw{
  margin-top:1.5vh;
}
.pw1{
  margin-top:1vh;
}
.is-checked{

}


.telCode {
  @extend .box;
  width: 24vw;
  opacity: 0.9;
  display: block;
  // height: 36vh;

  &-title {
    margin: 2vh 0px;
    font-size: 22px;
    color: #fff;
    text-align: center;
    font-family:'hanyi75';

    &-span {
      color: rgb(4,221,192);
    }
  }

  &-input {
    display: flex;
    flex-direction: column;
    padding: 0px 6vh;

    &-row {
      @extend .flex-row;
      margin:1.5vh 0px;

      &-code {
        width: 60%;
      }

      &-btn {
        width: 35%;
        @extend .yzbtn
      }
    }
    &-row1 {
      @extend .flex-row;
      margin:1vh 0px;

      &-code {
        width: 60%;
      }

      &-btn {
        width: 35%;
        @extend .yzbtn
      }
    }

    &-login {
      @extend .btn;
      margin: 1.5vh 0px 0.5vh 0px;
    }
    &-changepw{
      @extend .btn;
      margin: 2vh 0px 0.8vh 0px;
    }
  }

  &-bottom {
    // position: absolute;
    // bottom: 0px;
    height: 4vh;
    padding:2vh 2vh;
    background: rgba(16,16,16,1);
    border-radius: 0px 0px 20px 20px;
    color:rgb(197,198,199);
    font-size:14px;
    margin: 1vh 0px;

  }
}
.login{
  height: 450px;
}


@keyframes float5 {
  0% {
    transform: translate(20px, 20px);
  }
  50% {
    transform: translate(600px, 20px);
  }

  100% {
    transform: translate(20px, 20px);
  }
}

.float-animation5 {
  /* display: inline-block; */
  animation: float5 40s infinite;
}

.donghuap {
  display: flex;
  justify-content: center;
  /* flex-direction: column; */
  overflow-x: hidden;
  position: relative;
  text-align: center;
}

.donghuai {
  display: flex;
  transform: translateX(200%);
  transition: transform 0.4s ease;
  justify-content: center;
}

.adonghua {
  visibility: hidden;
}

.ddonghua {
  transform: translateX(0);
}

.edonghua {
  display: flex;
  transform: translateX(-200%);
  transition: transform 0.6s ease;
  justify-content: center;
}

.el-dropdown-menu__item {
  color: #ffffff;
  font-weight: bold;
  font-family: guanwangdaohang;
}

.popper__arrow {
  display: none;
}

.content {
  background: #939AA0;
  width: 100%;
  height: 100%;
}

body {
  overflow-x: hidden;
  overflow-y: hidden;
}

.el-scrollbar__wrap {
  background-color: black;
}

.bordered-box {
  overflow-wrap: break-word;
  /* margin-left: 20px; */
}

.beian1 {
  position: fixed; /* 定位为固定位置，覆盖整个视窗 */
  color: #616161;
  /* top: 0; */
  left: 42%;
  /* right: 0; */
  bottom: 0;

  z-index: 1000; /* 确保蒙层在其他内容之上 */
}


</style>



// WEBPACK FOOTER //
// src/components/main/login.vue